import { render, staticRenderFns } from "./ShortVideoRecom.vue?vue&type=template&id=13c4c0a6&scoped=true"
import script from "./ShortVideoRecom.vue?vue&type=script&lang=js"
export * from "./ShortVideoRecom.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoRecom.vue?vue&type=style&index=0&id=13c4c0a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4c0a6",
  null
  
)

export default component.exports